module.exports = "/fonts/Electrolize-Regular.3eb1b45863cb12d8c296aa3faf2cb317.ttf";